import { defineField, defineType } from "sanity";

const envs = ["develop", "demo", "production"];
const envNames = {
  env: ["dev", "qa", "prod"],
  name: ["web", "ios", "android"]
};

export const featureFlagType = defineType({
  type: "document",
  name: "featureFlag",
  title: "Feature Flag",
  groups: [
    { name: "platform", title: "Platform" },
    { name: "env", title: "Env" },
    { name: "build-target", title: "Build Target" }
  ],
  fields: [
    defineField({
      name: "flags_global",
      description:
        "Default settings for all environmnents and platforms, will over overwritten by any other config",
      type: "array",
      title: "Global Flags",
      of: [{ type: "featureFlagItem", title: "Flags" }]
    }),
    ...envNames.name.map((e) => {
      return defineField({
        name: `flags_${e}`,
        description: `Flags for ${e} platform, will be overwritten by envs and build-target`,
        type: "array",
        title: `Platform Flags: ${e}`,
        of: [{ type: "featureFlagItem", title: "Flags" }],
        group: "platform"
      });
    }),
    ...envs.map((e) => {
      return defineField({
        name: `flags_${e}`,
        description: `Flags for ${e} environment, will be overwritten by build-target`,
        type: "array",
        title: `ENV Flags: ${e}`,
        of: [{ type: "featureFlagItem", title: "Flags" }],
        group: "env"
      });
    }),
    ...envNames.name
      .map((n) => {
        return envNames.env.map((e) => {
          return defineField({
            name: `flags_${e}_${n}`,
            description: `Flags for ${e}-${n} build target`,
            type: "array",
            title: `Build Target Flags: ${e}-${n}`,
            of: [{ type: "featureFlagItem", title: "Flags" }],
            group: "build-target"
          });
        });
      })
      .flat()
  ]
});
